import React from 'react';
import { CPP_PropertyDetailsComponent } from './CPP_PropertyDetailsComponent';
import { CPP_PaymentPlanComponent } from './CPP_PaymentPlanComponent';
import { CPP_AmenitiesAndFacilitiesComponent } from './CPP_AmenitiesAndFacilitiesComponent';
import { CPP_ImagesComponent } from './CPP_ImagesComponent';
import { CPP_MarketingAllComponent } from './CPP_MarketingAllComponent';
import {
  Building04,
  BuildingEight,
  CreditCard01,
  Image02Icon,
  KeyMinimalistic02,
  Star06Icon,
} from '../../../../assets/icons';
import { CPP_UnitModelComponent } from './CPP_UnitModelComponent';

export const CompletePropertyProfileSteps = {
  PROPERTY_DETAILS: {
    id: 1,
    title: 'PROPERTY_DETAILS',
    Icon: <Building04 width='20' height='20' fill={'#475467'} />,
    component: CPP_PropertyDetailsComponent,
    percentage: 30,
    isPassed: false,
  },
  AMENITIES_AND_FACILITIES: {
    id: 2,
    title: 'AMENITIES_AND_FACILITIES',
    Icon: <KeyMinimalistic02 width='20' height='20' fill={'#475467'} />,
    component: CPP_AmenitiesAndFacilitiesComponent,
    percentage: 15,
    isPassed: false,
  },
  PAYMENT_PLAN: {
    id: 3,
    title: 'PAYMENT_PLAN',
    Icon: <CreditCard01 width='20' height='20' fill={'#475467'} />,
    component: CPP_PaymentPlanComponent,
    percentage: 10,
    isPassed: false,
  },
  UNIT_MODEL: {
    id: 4,
    title: 'UNIT_MODEL',
    Icon: <BuildingEight width='20' height='20' fill={'#475467'} />,
    component: CPP_UnitModelComponent,
    percentage: 10,
    isPassed: false,
  },
  IMAGES: {
    id: 5,
    title: 'IMAGES',
    Icon: <Image02Icon width='20' height='20' fill={'#475467'} />,
    component: CPP_ImagesComponent,
    percentage: 25,
    isPassed: false,
  },
  MARKETING_ALL: {
    id: 6,
    title: 'MARKETING_ALL',
    Icon: <Star06Icon width='20' height='20' fill={'#475467'} />,
    component: CPP_MarketingAllComponent,
    percentage: 10,
    isPassed: false,
  },
};
